import './ui/styles.css';
import { startApp } from './ui/app';

const root = document.getElementById('app');
if (root) {
  void startApp(root);
}

// Register the service worker for offline shell (progressive enhancement).
// The worker itself calls skipWaiting()/clients.claim() as soon as a new
// version activates; reloading here on controllerchange is what turns that
// into a silent, automatic update instead of one that only applies on the
// next manual page load.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').then((registration) => {
      // Poll for a new version periodically, since a long-lived open tab
      // otherwise never re-fetches sw.js on its own.
      setInterval(() => void registration.update(), 60 * 60 * 1000);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') void registration.update();
      });
    });

    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
